/** Incrémenter à chaque déploiement front chat (aligné meta index.html + service-worker.js). */
export const CHAT_BUILD_VERSION = "20260915chat1";

export const CHAT_BUILD_VERSION_LS_KEY = "chat_build_version";
